// istanbul ignore file

import { HostActions } from '@makemydeal/dr-activities-change-vehicle';

export const hostActions: HostActions = {
    navigateToDashboard: () => ({ type: 'UNKNOWN' }), // @TODO: to be implemented in further tasks
    switchVehicle: () => ({ type: 'UNKNOWN' }) // @TODO: to be implemented in further tasks
};
